import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider, css } from 'styled-components';
import { connect } from 'formik';
import { ThemeShape, Default } from '../theme/Options';
import { questionTypes } from '../../constants/questionnaires';

const StyledOptions = styled.div`
  ${({ theme }) => theme.container}
`;

const Item = styled.div`
  cursor: pointer;
  
  ${({ theme }) => theme.item}

  ${({ isSelected }) => isSelected && css`
    ${({ theme }) => theme.selected}
  `}
`;

class Options extends Component {
  state = {
    selectedItems: [...this.props.default],
  };

  componentDidMount = () => {
    document.addEventListener('keyup', this.keyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.keyUp, false);
  }

  keyUp = (ev) => {
    //console.log("keyUpOptions");
    //console.log('isFocused: ', this.props.isFocused);
    //console.log('importantKeyIsDown: ', this.props.importantKeyIsDown);
    if (this.props.importantKeyIsDown && (this.props.isFocused || this.props.multiple)) {
      ev.preventDefault();
      //console.log("insideee condition");
      const {
        name,
        values,
        multiple,
        justValue,
        callback,
      } = this.props;
      callback();
      let index = null;

      switch (ev.keyCode) {
        case 65:
        case 97:
        case 66:
        case 98:
        case 67:
        case 99:
        case 68:
        case 100:
        case 69:
        case 101:
        case 70:
        case 102:
        case 71:
        case 103:
        case 72:
        case 104:
        case 73:
        case 105:
        case 74:
        case 106:
        case 83:
        case 115:
        case 78:
        case 110:
          //console.log("inside");
          //console.log("bbb");
          //console.log(multiple);
          if (!multiple) {
            switch (ev.keyCode) {
              // A a
              case 65:
              case 97:
              case 83:
              case 115:
                index = 0;
                break;
              // B b
              case 66:
              case 98:
              case 78:
              case 110:
                index = 1;
                break;
              // C c
              case 67:
              case 99:
                index = 2;
                break;
              // D d
              case 68:
              case 100:
                index = 3;
                break;
              default:
                break;
            }
          } else {
            switch (ev.keyCode) {
              // A a
              case 65:
              case 97:
                index = 0;
                break;
              // B b
              case 66:
              case 98:
                index = 1;
                break;
              // C c
              case 67:
              case 99:
                index = 2;
                break;
              // D d
              case 68:
              case 100:
                index = 3;
                break;
              // E e
              case 69:
              case 101:
                index = 4;
                break;
              // F f
              case 70:
              case 102:
                index = 5;
                break;
              // G g
              case 71:
              case 103:
                index = 6;
                break;
              // H h
              case 72:
              case 104:
                index = 7;
                break;
              // I i
              case 73:
              case 105:
                index = 8;
                break;
              // J j
              case 74:
              case 106:
                index = 9;
                break;
              default:
                break;
            }
          }
          // Selecting multiple
          // Selecting a single one and moving forward...
          
          if (multiple && values[index]) {
            //console.log('here1');
            this.handleOnClick(name, { ...values[index] }, multiple, justValue, () => {});
          }
    
          if (values[index] && this.state.selectedItems.length === 0) {
            //console.log('here2');
            this.handleOnClick(name, { ...values[index] }, multiple, justValue, () => {});
          }
          break;
        default:
          break;
      }
    }
  }

  componentWillReceiveProps = (newProps) => {
    const prevValues = this.props.values;
    const newValues = newProps.values;

    if (prevValues.length + 1 === newValues.length) {
      const valuesCopy = [...newValues];
      const newItem = valuesCopy.pop();
      const newList = this.updateListWithItem(newItem, true);
      this.selectItems(newList, this.setItem(this.props.name, newList, newProps.multiple));
    }
  }

  setItem = (name, list, multiple) => {
    let newList = multiple ? list : list[0];
    this.props.onItemSelected(newList);
    if (this.props.justValue) {
      newList = newList.value;
    }
    this.props.formik.setFieldValue(name, newList);
  }

  selectItems = (newList, cb) => {
    //console.log(newList);
    this.setState({ selectedItems: newList }, cb);
  };

  handleOnClick = (name, item, multiple, justValue, cb) => {
    //console.log(name, item, multiple, justValue, cb);
    if (item.runCallback) {
      cb();
    } else {
      const newList = this.updateListWithItem(item, multiple, justValue);
      this.selectItems(newList, this.setItem(name, newList, multiple));
      cb();
    }
  }

  updateListWithItem = (item, multiple) => {
    const newList = multiple ? this.state.selectedItems : [];
    const selectedItemIndex = newList.findIndex(i => i.value === item.value);

    if (selectedItemIndex >= 0) {
      newList.splice(selectedItemIndex, 1);
    } else {
      newList.push(item);
    }


    return newList;
  }

  isItemSelected = (list, item) => list.find(i => i.value === item.value);

  render() {
    const { name, values, multiple, justValue, theme, renderItem, callback, ...rest } = this.props;
    return (
      <ThemeProvider theme={theme}>
        <StyledOptions {...rest}>
          {values && values.map((item, index) => (
            <Item
              key={index}
              isSelected={this.isItemSelected(this.state.selectedItems, item)}
              onClick={() => {
                if (item.customOnClick) {
                  if (typeof item.customOnClick === 'string') {
                    if (item.blank === true) window.open(item.customOnClick, '_blank');
                    else window.open(item.customOnClick, '_self');
                  } else {
                    item.customOnClick();
                  }
                } else {
                  this.handleOnClick(name, { ...item, index }, multiple, justValue, callback);
                }
              }}
            >
              {renderItem ? renderItem({
                ...item,
                isSelected: !!this.isItemSelected(this.state.selectedItems, item),
              }) : item.label}
            </Item>
          ))}
        </StyledOptions>
      </ThemeProvider>
    );
  }
}

Options.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    customOnClick: PropTypes.string,
  })),
  multiple: PropTypes.bool,
  justValue: PropTypes.bool,
  renderItem: PropTypes.func,
  callback: PropTypes.func,
  onItemSelected: PropTypes.func,
  default: PropTypes.arrayOf(PropTypes.object),
  theme: ThemeShape,
  formik: PropTypes.object,
  isFocused: PropTypes.bool,
};

Options.defaultProps = {
  values: [],
  multiple: false,
  justValue: false,
  default: [],
  callback: () => {},
  renderItem: undefined,
  onItemSelected: () => { },
  theme: Default,
  formik: {},
  isFocused: null,
};

export default connect(Options);
